// extracted by mini-css-extract-plugin
module.exports = {"centered__text":"centeredtext_centered__text__iwoXF","container":"centeredtext_container__ypjDk"};